import Vue from "vue";
import { bus } from "@/main";
import { getMenuEntry } from "@/data/models/menu.model";

export default {
	props:[
		"title",
		"date",
		"subTitle",
		"size",
	],
	data() {
		return {
		}
	},
	created() {
	},
	watch: {
	},
	methods: {
	}
}


// WEBPACK FOOTER //
// ./src/components/blocks/list-block/list.block.js